export default {
  name: 'errorHandlerMixin',
  methods: {
    async errorHandler (error) {
      if (typeof error === 'object' && 'response' in error) {
        await this.addError(error.response.data.message)
      } else if (typeof error === 'object' && 'data' in error) {
        await this.addError(error.data.message)
      } else if (typeof error === 'string') {
        await this.addError(error)
      } else {
        await this.addError('An error occurred during your request. Report at support@ipark.gr')
      }
      this.$store.commit('setLoading', false)
    },
    async addError (error) {
      this.$store.commit('set_error', error)
    },
    async removeError (errorId) {
      this.$store.commit('remove_error', errorId)
    },
  },
  computed: {
    getErrors () {
      return this.$store.getters.errors
    },
  },
}
